var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserImgRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "solar:user-linear"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.4974 14.5833C20.7191 14.5833 23.3307 11.9716 23.3307 8.74996C23.3307 5.5283 20.7191 2.91663 17.4974 2.91663C14.2757 2.91663 11.6641 5.5283 11.6641 8.74996C11.6641 11.9716 14.2757 14.5833 17.4974 14.5833Z",
    stroke: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M29.1654 25.5208C29.1654 29.1447 29.1654 32.0833 17.4987 32.0833C5.83203 32.0833 5.83203 29.1447 5.83203 25.5208C5.83203 21.8968 11.0558 18.9583 17.4987 18.9583C23.9416 18.9583 29.1654 21.8968 29.1654 25.5208Z",
    stroke: "#FF0000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserImgRed);
export default __webpack_public_path__ + "static/media/user_img_red.658247f3aeb53a686a21ddad0a0af4ec.svg";
export { ForwardRef as ReactComponent };